angular.module('estoffice.legacy').controller('ObjectsCtrl', objectsCtrl);

function objectsCtrl($rootScope, $scope, $timeout, $cookieStore) {
  $scope.projects = [];
  /*var unitId = window.location.hash.split('/')[1];
	if(unitId){
	$timeout(function(){
	  $('.js-object[data-unit-id=' + unitId +']').trigger('click');
	});
	}*/

  // Открытие нужного объекта после перезагрузки страницы
  var objectCookie = $cookieStore.get('object');

  if (objectCookie) {
    $timeout(function () {
      angular
        .element('.b-projects__item[data-unit-id=' + objectCookie + ']')
        .parent()
        .parent()
        .children()
        .triggerHandler('click');
      angular
        .element('.b-projects__item[data-unit-id=' + objectCookie + ']')
        .triggerHandler('click');
    });
  }
  $cookieStore.remove('object');
}
